module.exports = __webpack_public_path__ + "img/PD.5349ae38.png";